<script lang="ts">
	import { onMount } from 'svelte';
	import { readSettings } from '$lib/settings';
	import LogoIcon from './LogoIcon.svelte';
	let { size = 36, text = 'BUBBLE GAMES' }: { size?: number; text?: string } = $props();

	let currentTheme = $state('hearth');

	onMount(() => {
		currentTheme = readSettings().theme;
		const onStorage = () => { currentTheme = readSettings().theme; };
		window.addEventListener('storage', onStorage);
		return () => window.removeEventListener('storage', onStorage);
	});
</script>

<div class="logo-full" style="display: inline-flex; position: relative;">
<div class="logo-pill relative" style="overflow: visible; display: inline-flex;">
	<div class="pixel-frame relative flex items-center" style:height="{size}px">
		<div class="pixel-frame absolute inset-0 bg-(--logo-frame-outer)"></div>
		<div class="pixel-frame absolute inset-0.5 bg-(--logo-frame-highlight)"></div>
		<div class="pixel-frame absolute inset-1.5 bg-(--logo-frame-shadow)"></div>
		<div class="pixel-frame absolute inset-2 bg-(--logo-frame-fill)"></div>
		{#if currentTheme === 'overgrown'}
			<!-- crack lines -->
			<div class="pointer-events-none absolute inset-0 z-20 overflow-hidden" style="border-radius: var(--frame-radius);">
				<div style="position: absolute; top: 3px; left: 3px; width: 22px; height: 1px; background: rgba(255,255,255,0.22); transform: rotate(28deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 7px; left: 3px; width: 14px; height: 1px; background: rgba(255,255,255,0.14); transform: rotate(-15deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 5px; left: 12px; width: 10px; height: 1px; background: rgba(255,255,255,0.10); transform: rotate(55deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 3px; right: 4px; width: 20px; height: 1px; background: rgba(255,255,255,0.18); transform: rotate(-22deg); transform-origin: right center;"></div>
				<div style="position: absolute; top: 6px; right: 6px; width: 12px; height: 1px; background: rgba(255,255,255,0.11); transform: rotate(40deg); transform-origin: right center;"></div>
				<div style="position: absolute; bottom: 4px; right: 4px; width: 18px; height: 1px; background: rgba(255,255,255,0.16); transform: rotate(18deg); transform-origin: right center;"></div>
				<div style="position: absolute; bottom: 7px; right: 10px; width: 10px; height: 1px; background: rgba(255,255,255,0.10); transform: rotate(-35deg); transform-origin: right center;"></div>
				<div style="position: absolute; top: 45%; left: 30%; width: 16px; height: 1px; background: rgba(255,255,255,0.13); transform: rotate(-20deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 48%; left: 36%; width: 9px; height: 1px; background: rgba(255,255,255,0.08); transform: rotate(42deg); transform-origin: left center;"></div>
			</div>
			<!-- scratch marks -->
			<div class="pointer-events-none absolute inset-0 z-20 overflow-hidden" style="border-radius: var(--frame-radius);">
				<div style="position: absolute; top: 8px; left: 25%; width: 18px; height: 1px; background: rgba(255,255,255,0.12); transform: rotate(-38deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 10px; left: 27%; width: 10px; height: 1px; background: rgba(255,255,255,0.07); transform: rotate(-38deg); transform-origin: left center;"></div>
				<div style="position: absolute; bottom: 6px; left: 50%; width: 14px; height: 1px; background: rgba(255,255,255,0.10); transform: rotate(25deg); transform-origin: left center;"></div>
				<div style="position: absolute; top: 6px; left: 60%; width: 12px; height: 1px; background: rgba(255,255,255,0.09); transform: rotate(-20deg); transform-origin: left center;"></div>
			</div>
		{/if}
		<div class="relative flex items-center gap-1 pr-3">
			<LogoIcon {size} showBeta={false} />
			<span class="font-bold uppercase" style:font-size="{Math.round(size * 0.55)}px" style:color="var(--logo-frame-text)" style:text-shadow={currentTheme === 'catchers' ? '1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000' : 'none'}>{text}</span>
		</div>
	</div>
</div>
</div>

